import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText } from "components/MyControl";
import Swal from "sweetalert2";

export default function UserGroupDetail() {
    const nav = useNavigate();
    const api = new ApiConection();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [createMode,setCreateMode] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});
    const [menuMaster, setMenuMaster] = useState([]);
    const urlPathName = window.location.pathname;


    const getData = async () => {
        const response = await api.getData(`api/UsersGroup/${id}`);
        if (response.status === true) {
            setSimulate(response.data);
            setInitialData(response.data);
        }
    }

    const getMenu = async () => {
        if(simulate.identity_role === 'admin'){
            const response = await api.getData(`api/Menu/admin`);
            if (response.status === true) {
                setMenuMaster(response.data)
            }
        }else{
            const response = await api.getData(`api/Menu/customer`);
            if (response.status === true) {
                setMenuMaster(response.data)
            }
        }
       
    }

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/usergroups/create')){
            setMode('edit');
            setCreateMode(true);
        }
    },[urlPathName])

    useEffect(() => {
        
        getData();
        
    }, [])

    useEffect(()=>{
        getMenu();
    },[simulate.identity_role])

    const handleSetSimulate = async (event) => {
        const { name, value, checked, type } = event.target;
            if(type === 'checkbox'){
                setSimulate(preData => { return { ...preData, [name]: checked } });
            }else{
                setSimulate(preData => { return { ...preData, [name]: value } });
            }
     }

     const handleSetSimulateArrMenu =  (event)=>{
        
        const { name, value, checked, type } = event.target;

        let arr_menu = simulate?.arr_menu ?? [];

    
        //console.log(arr_menu);
        //console.log(value);
        if(arr_menu?.findIndex( x => parseInt( x.id) === parseInt(value)  ) > -1)
            arr_menu.splice(arr_menu.findIndex( x => parseInt(x.id) ===  parseInt(value)),1);

        if(checked === true)
            arr_menu.push({id:value});
       
        setSimulate(preData => { return { ...preData, ['arr_menu']: arr_menu } });
     }

    const handleBreadcrumbClick = (e) => {
        nav('/usergroups');
    };
    
    const handleCancel = (event) => {
        if (createMode) {
            nav('/usergroups'); 
        } else {
            setSimulate(initialData);
            setMode('view');
        }
    }
    

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let data = {
            name: simulate.name,
            description: simulate.description,
            identity_role: simulate.identity_role,
            active: simulate.active,

            user_group_id: simulate.user_group_id,
            arr_menu: simulate.arr_menu,
        }


        if (urlPathName === (process.env.PUBLIC_URL+'/usergroups/create')){
            const response = await api.postData(`api/UsersGroup`, data)
            if (response.status === true) {
                nav('/usergroups')
            } else{
                setAlert(response.message);
            }
        } else {
            const response = await api.putData(`api/UsersGroup/${id}`,data);

            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        setLoading(false);
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'ต้องการลบข้อมูลผู้ใช้ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#727a82',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {
                api.deleteData(`api/UsersGroup/${id}`)
                .then((response) => {
                    if (response.status === true) {
                        Swal.fire({title:'ลบสำเร็จ', icon:'success',heightAuto: false});
                        nav('/usergroups');
                    } else {
                        Swal.fire({title:'เกิดข้อผิดพลาด', icon:'error',heightAuto: false});
                    }
                })
            }
        })
    }

    return (
        <Layout4Admin1>
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>จัดการผู้ใช้</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'ข้อมูลสิทธิ์ผู้ใช้' :
                                createMode === true ? 'เพิ่มสิทธิ์ผู้ใช้' :
                                'แก้ไขข้อมูลสิทธิ์ผู้ใช้'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'ข้อมูลสิทธิ์ผู้ใช้' :
                                                createMode === true ? 'เพิ่มสิทธิ์ผู้ใช้' :
                                                'แก้ไขข้อมูลสิทธิ์ผู้ใช้'
                                            }
                                        </h5>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                    
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3 '>
                                        <Form.Group as={Row}  className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อ</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className={(mode === 'view')? 'ps-2' : ''}
                                                name={'name'}
                                                value={simulate?.name}
                                                onChange={handleSetSimulate}
                                                placeholder="ชื่อ" 
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group as={Row}  className='mb-3'>
                                            <Form.Label className='label-title'>รายละเอียด</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className={(mode === 'view')? 'ps-2' : ''}
                                                name={'description'}
                                                value={simulate?.description}
                                                onChange={handleSetSimulate}
                                                placeholder="รายละเอียด" 
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group as={Row} className='mb-3'>
                                                <Form.Label className='label-title'>สำหรับระบบ</Form.Label>
                                                {
                                                    mode === 'view' &&
                                                    <Form.Label>{simulate?.identity_role}</Form.Label>
                                                }
                                                {
                                                mode === 'edit' &&
                                                <Form.Select name={'identity_role'}
                                                    className=""
                                                    value={simulate?.identity_role }
                                                    required={true}
                                                    onChange={handleSetSimulate} >
                                                    <option value=''>--เลือกระบบ--</option>
                                                    <option value='admin'>admin</option>
                                                    <option value='customer'>customer</option>
                                                    
                                                </Form.Select>
                                                 }
                                        </Form.Group>
                                        {simulate?.identity_role && (
                                            <Form.Group as={Row} className='mb-3'>
                                            <Form.Label className='label-title'>จัดการเมนู</Form.Label>
                                                {
                                                    menuMaster.map((obj,index)=>(
                                                        <div key={index} className={(obj.parent_id !== null)? 'mb-2 ms-4' : 'mb-2'}>
                                                            <Form.Check 
                                                            name={`chk_menu_${obj.id}`}
                                                            id={`chk_menu_${obj.id}`} 
                                                            label={obj.name} 
                                                            value={obj.id}
                                                            checked={simulate.arr_menu?.find(x => parseInt(x.id)  === parseInt(obj.id) ) !== undefined}
                                                            onChange={handleSetSimulateArrMenu} 
                                                            disabled={(mode === 'view') ? true : false} />
                                                        </div>
                                                ))}   
                                            </Form.Group>
                                        )}
                                        
                                    </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่สร้าง</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.create_date)}</Form.Label>
                                        </Form.Group>

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">วันที่แก้ไขล่าสุด</Form.Label>
                                                <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                            </Form.Group>
                                            
                                        }

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">แก้ไขโดย</Form.Label>
                                                <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                        
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>Active</Form.Label>
                                        <Form.Check type={'switch'}
                                            id={'active'}
                                            name={'active'}
                                            disabled={(mode === 'view') ? true : false}
                                            onChange={event => handleSetSimulate(event)}
                                            checked={simulate?.active}
                                            label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                        />
                                    </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-danger" type="button" className=''
                                        onClick={event => handleDelete(id)}>
                                        ลบ
                                        <i className="ms-2 fa-solid fa-trash"></i>
                                    </Button>
                                }
                            </Col>

                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                            <Row>
                                <Col>
                                    {createMode && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                    {!createMode && mode === 'edit' && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                บันทึก
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}